import { inlineMediaQueryMixin, token } from "@zillow/constellation";
const radiusMixin = (radius) => token({
  radii: "radii"
}, ({
  radii
}) => {
  let value = 0;
  if (radii) {
    if (radius in radii) {
      value = radii[radius];
    }
  }
  if (Number.isInteger(value)) {
    return `${value}px`;
  }
  return value;
});
const borderRadiusMixin = (props) => {
  const styles = [];
  let addOverflow = false;
  if ("borderRadius" in props) {
    addOverflow = true;
    styles.push(inlineMediaQueryMixin("borderRadius", (mediaProps) => `border-radius: ${radiusMixin(mediaProps.borderRadius)(mediaProps)};`)(props));
  }
  if ("borderRadiusTopRight" in props) {
    addOverflow = true;
    styles.push(inlineMediaQueryMixin("borderRadiusTopRight", (mediaProps) => `border-top-right-radius: ${radiusMixin(mediaProps.borderRadiusTopRight)(mediaProps)};`)(props));
  }
  if ("borderRadiusTopLeft" in props) {
    addOverflow = true;
    styles.push(inlineMediaQueryMixin("borderRadiusTopLeft", (mediaProps) => `border-top-left-radius: ${radiusMixin(mediaProps.borderRadiusTopLeft)(mediaProps)};`)(props));
  }
  if ("borderRadiusBottomRight" in props) {
    addOverflow = true;
    styles.push(inlineMediaQueryMixin("borderRadiusBottomRight", (mediaProps) => `border-bottom-right-radius: ${radiusMixin(mediaProps.borderRadiusBottomRight)(mediaProps)};`)(props));
  }
  if ("borderRadiusBottomLeft" in props) {
    addOverflow = true;
    styles.push(inlineMediaQueryMixin("borderRadiusBottomLeft", (mediaProps) => `border-bottom-left-radius: ${radiusMixin(mediaProps.borderRadiusBottomLeft)(mediaProps)};`)(props));
  }
  if (addOverflow) {
    styles.push("overflow: hidden;");
  }
  return styles;
};
export {
  borderRadiusMixin,
  radiusMixin
};
